import { BetaGameCard } from './BetaGameCard'
import { HurdleCard } from './HurdleCard'
import { ModuleCard } from './ModuleCard'
import { ChapterCard } from './ChapterCard'
import { LearnGroupCard } from './LearnGroupCard'
import { AnyFunction, useMemo } from '@codeleap/common'
import { Module } from '@/types'
import { useSharedSettings } from '@/services'
import { canPlayHurdle } from '@/utils'
import { canOpenLesson } from '@/features/Learn/utils/lesson'
import { useOpenModule } from '../../hooks'
export * from './PersonaCard'

export const moduleCards: Record<Module['type'], AnyFunction> = {
  game: BetaGameCard,
  hurdle: HurdleCard,
  lesson: ModuleCard,
  all: ModuleCard,
  video: ModuleCard,
  chapter: ChapterCard,
  lesson_group: LearnGroupCard,
}

export const LearnCard = ({
  item,
  onPress: providedOnPress,
}: {
  item: Module
  onPress?: AnyFunction
}) => {
  const sharedSettings = useSharedSettings()

  const { resolveModuleAction } = useOpenModule()

  const isHurdle = item?.title?.toLowerCase() === 'hurdle'
  if (isHurdle) item.type = 'hurdle'

  const { isCanOpenLesson, isModuleFromInitialLesson } = useMemo(() => {
    const initialLesson = sharedSettings?.settings?.initial_lesson

    const isLesson = item?.pages?.length > 0

    const isCanOpenLesson = isLesson
      ? canOpenLesson(item.id)
      : item?.chapters?.some(c => canOpenLesson(c.id))

    const isModuleFromInitialLesson = item?.chapters?.some(
      c => c?.id === initialLesson
    )

    return { isCanOpenLesson, isModuleFromInitialLesson }
  }, [item?.chapters])

  const isDisabled = useMemo(() => {
    if (isHurdle) return !canPlayHurdle()

    if (item?.chapters?.length > 1) return false

    return !item?.is_free && !isModuleFromInitialLesson && !isCanOpenLesson
  }, [isHurdle, isCanOpenLesson, isModuleFromInitialLesson])

  const onPressStrategy = resolveModuleAction(item, isModuleFromInitialLesson)

  const onPress = () => {
    providedOnPress?.()
    onPressStrategy.execute(item)
  }

  const Card = moduleCards[item?.type ?? 'lesson']

  return (
    <Card module={item} item={item} onPress={onPress} disabled={isDisabled} />
  )
}

export { LearnGroupCard, ChapterCard, ModuleCard, HurdleCard, BetaGameCard }
